import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { faEye } from "../../assets/fontAwesome/duotone/faEye";
import { faEyeSlash } from "../../assets/fontAwesome/duotone/faEyeSlash";
import { TextInput } from "./TextInput";
export const PasswordInput = (props) => {
    const [showPassword, setShowPassword] = useState(false);
    return (_jsx(TextInput, Object.assign({}, props, { inputProps: Object.assign({ type: showPassword ? "text" : "password", autoComplete: props.newPassword ? "new-password" : undefined }, props.inputProps), endButton: {
            icon: showPassword ? faEyeSlash : faEye,
            onClick: () => setShowPassword(!showPassword),
        } })));
};
